import { INITIAL_DOSSIERS_OPTIONS } from '../../../lib/dossiers/store/dossiers/dossiers.model';

export const BERTH_OVERVIEW_DOSSIERS_OPTIONS = {
	...INITIAL_DOSSIERS_OPTIONS,
	'page-size': 50,
};

export const BERTH_TIMELINE_GROUP_PREFIX = 'Berth';
